import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { FileText, Download } from "lucide-react";

export default function Documents() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/documents").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  const grouped = items.reduce((acc, d) => {
    (acc[d.category] = acc[d.category] || []).push(d);
    return acc;
  }, {});

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-10 lg:py-14" data-testid="documents-page">
      <div className="mb-10">
        <span className="text-xs tracking-[0.3em] uppercase text-[#1E3A8A] font-bold">Téléchargements</span>
        <h1 className="mt-2 text-4xl sm:text-5xl font-extrabold text-[#0F172A] tracking-tighter" style={{ fontFamily: "Outfit" }}>
          Documents<span className="text-[#D97706]">.</span>
        </h1>
        <p className="mt-3 text-[#475569] max-w-2xl">
          Dossiers d'inscription, certificats, règlement intérieur : tout ce dont vous avez besoin, en un clic.
        </p>
      </div>

      {Object.entries(grouped).map(([cat, docs]) => (
        <div key={cat} className="mb-8">
          <h2 className="text-xs tracking-[0.3em] uppercase font-bold text-[#D97706] mb-3 flex items-center gap-3">
            <span>{cat}</span>
            <span className="h-px bg-[#E2E8F0] flex-1" />
          </h2>
          <div className="grid sm:grid-cols-2 gap-3">
            {docs.map((d) => (
              <a
                key={d.id}
                href={d.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`doc-${d.id}`}
                className="group flex items-start gap-4 p-5 border border-[#E2E8F0] rounded-lg bg-white hover:border-[#1E3A8A] hover:-translate-y-0.5 transition-all duration-200"
              >
                <div className="shrink-0 w-11 h-11 rounded-md bg-[#1E3A8A]/10 flex items-center justify-center text-[#1E3A8A] group-hover:bg-[#1E3A8A] group-hover:text-white transition-colors">
                  <FileText size={20} />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-bold text-[#0F172A] group-hover:text-[#1E3A8A] transition-colors" style={{ fontFamily: "Outfit" }}>{d.title}</div>
                  {d.description && <div className="text-xs text-[#475569] mt-1">{d.description}</div>}
                </div>
                <Download size={16} className="text-[#CBD5E1] group-hover:text-[#D97706] shrink-0 mt-1" />
              </a>
            ))}
          </div>
        </div>
      ))}

      {items.length === 0 && (
        <div className="text-center py-16 border border-dashed border-[#E2E8F0] rounded-lg text-[#475569]">
          Aucun document disponible pour le moment.
        </div>
      )}
    </div>
  );
}
